



























import { Component, Vue, Prop, Watch, State } from 'nuxt-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import BellLoading from './loading.vue'
import apiNameMap from '~/share/data/apis'
import { Tour } from '~/types/tour'
import { resizeImg } from '~/share/utils'

@Component({
  components: {
    BellLoading
  }
})
export default class TourHomeRecommendActivity extends Vue {
  @Prop({ default: () => [] }) dataList!: any
  @Prop({ type: Number }) position!: number
  @Prop({ type: Number, default: 0 }) sliceEnd!: number
  @State klook!: Data.Klook

  cloneDataList: Tour.RecommendItem[] = []

  get isDesktop() {
    return this.klook.platform === 'desktop'
  }

  @Watch('dataList', { deep: true, immediate: true })
  onDataListChange(val: any) {
    if (val?.length) {
      this.cloneDataList = this.formatDataList(val)
    }
  }

  formatDataList(list: Tour.RecommendItem[]) {
    /*
      pc端
        外层: 7个
        弹窗内: 6个。弹窗内必须固定为6个，有可能第七个的高度影响到其他6个的样式
      mweb
       显示全部
    */
    let source = cloneDeep(list)
    const w = this.isDesktop ? 280 : 170

    if (this.sliceEnd) {
      source = source.slice(0, this.sliceEnd)
    }

    return source.map((item: Tour.RecommendItem) => {
      item.image_url = resizeImg(item.image_url, w, w)
      return item
    })
  }

  async getActivityCount() {
    if (this.dataList?.length) {
      const city_id_list: number[] = []
      const country_id_list: number[] = []

      this.dataList.forEach((item: any) => {
        const { city_id = '', country_id = '' } = item

        if (city_id) {
          city_id_list.push(city_id)
        }

        if (country_id) {
          country_id_list.push(country_id)
        }
      })

      const params: any = {}

      if (city_id_list.length) {
        params.city_id_list = city_id_list.join(',')
      }

      if (country_id_list.length) {
        params.country_id_list = country_id_list.join(',')
      }

      const { success, result } = await this.$axios.$get(apiNameMap.getRecommendActivityCount, { params })

      if (success && result) {
        const resultMap = (result?.items || []).reduce((p: any, o: any) => {
          const { city_id = '', country_id = '' } = o
          p[city_id || country_id] = o
          return p
        }, {})

        this.mergeDataList(resultMap)
      }
    }
  }

  mergeDataList(mergeObj: any) {
    if (this.cloneDataList?.length) {
      const source = cloneDeep(this.cloneDataList)

      const list: Tour.RecommendItem[] = source.map((item: Tour.RecommendItem) => {
        const { city_id = '', country_id = '' } = item
        const id = city_id || country_id

        if (mergeObj[id]) {
          item = {
            ...item,
            ...mergeObj[id]
          }
        }

        return item
      })

      this.cloneDataList = list
    }
  }

  getSpm(card: Tour.RecommendItem, index: number) {
    const { city_id, country_id, poi_id, track_info = {} } = card || {}

    let oid = ''

    if (city_id) {
      oid = `city_${city_id}`
    }

    if (country_id) {
      oid = `country_${country_id}`
    }

    if (poi_id) {
      oid = `poi_${poi_id}`
    }

    return `RecommendDestination_LIST?oid=${oid}&ext=${encodeURIComponent(JSON.stringify(track_info))}&idx=${index}&len=${this.cloneDataList.length}`
  }

  checkShowSeparate() {
    if (process.client) {
      const texts = this.$el && this.$el?.querySelectorAll('.text')

      if (texts?.length) {
        const includesLangs = ['en', 'es', 'id', 'ru', 'it', 'fr', 'ms', 'de']
        const [curLan] = this.klook.language.split('-')

        Array.from(texts).forEach((text: Element, index: number) => {
          const { height } = text.getBoundingClientRect()
          const content = (this.cloneDataList[index]?.text || '').split(' ')

          // 只有一个单词 && 长度超出一行 && 英文
          if (
            includesLangs.includes(curLan.toLocaleLowerCase()) &&
            height > 30 &&
            content.length === 1
          ) {
            const prev = text.previousElementSibling as HTMLElement
            const parent = text.parentNode as HTMLElement

            parent.style.paddingRight = '4px'
            prev.style.display = 'block'
          }
        })
      }
    }
  }

  mounted() {
    this.checkShowSeparate()
  }

  created() {
    this.getActivityCount()
  }
}
